export default __webpack_public_path__ + "static/media/forskola.e38c8244.jpeg";